import { Component } from '@angular/core';
import { PreferredMeasurementService } from 'src/app/services/preferred-measurement.service';

@Component({
  selector: 'me-unit-of-measure',
  template: `{{weightUnitOfMeasure$ | async}}`,
})
export class UnitOfMeasureComponent {
  weightUnitOfMeasure$ = this.$preferredMeasurementService.weightUnitOfMeasure$;

  constructor(private $preferredMeasurementService: PreferredMeasurementService) { }

}
